import script from "./manager.vue?vue&type=script&setup=true&lang=js"
export * from "./manager.vue?vue&type=script&setup=true&lang=js"

import "./manager.vue?vue&type=style&index=0&id=166997e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166997e4"]])

export default __exports__